<div class="modal-background" *ngIf="show">
    <div class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Desea Aprobar esta {{data.length}} Imagenes?</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closed()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Necesita Descargar la imagen para retoques o dejarla tal cual y convertirla en imagen
                  de ficha?
              </p>
            </div>
            <div class="modal-footer" *ngIf="tipe==='multiselect'">         
              <button type="button" class="btn btn-primary btn-block" (click)="acceptedAll()">Aprobar {{data.length}} imagenes </button>
            </div>
            <div class="modal-footer" *ngIf="tipe==='download'">         
              <button type="button" class="btn btn-info btn-block" (click)="downloadAll()">Descargar y aprobar {{data.length}} imagenes </button>
            </div>
            <div class="modal-footer" *ngIf="tipe ===''">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="download()">Descargar</button>
              <button type="button" class="btn btn-primary" (click)="accepted()">Aprobar</button>
            </div>

          </div>
        </div>
      </div>

</div>
